export type DragDropTypes = 'stage';

export const DRAG_DROP_TYPES: Record<Uppercase<DragDropTypes>, DragDropTypes> = {
  STAGE: 'stage',
};
